export class AnalysisContentWidgetModel {
  id: number;
  contentId: number;
  name: string;
  type: string;
  widgetTitle: string;
  columnSpan: number;
  rowSpan: number;
  setup: any;
  templateWidgetId: any;
  nodes: any[];
  pinned: any[];
  availablePagesByObject: any;
  sourceData: any[];
  _objectNodeExcludeLookup = null;
  _objectNodeLookup = null;
  visible: boolean = true;

  constructor(analysisContentWidget?) {
    this.id = analysisContentWidget.id;
    this.contentId = analysisContentWidget.contentId;
    this.name = analysisContentWidget.name;
    this.type = analysisContentWidget.type;
    this.widgetTitle = analysisContentWidget.widgetTitle;
    this.columnSpan = analysisContentWidget.columnSpan;
    this.rowSpan = analysisContentWidget.rowSpan;
    if (typeof analysisContentWidget.setup === 'string') {
      this.setup = JSON.parse(analysisContentWidget.setup);
    } else {
      this.setup = analysisContentWidget.setup;
    }
    this.templateWidgetId = analysisContentWidget.templateWidgetId;
    this.nodes = analysisContentWidget.nodes;
    this.pinned = analysisContentWidget.pinned;
    this.availablePagesByObject = analysisContentWidget.availablePagesByObject;
    this.sourceData = analysisContentWidget.sourceData;
    this.visible = analysisContentWidget.visible;
  }

  addNode = (contentObject, node, isGroup) => {
    let objectNode = this.findNode(node.nodeId, contentObject.objectPath);
    if (!objectNode) {
      objectNode = {
        objectPath: contentObject.objectPath,
        nodeId: node.id,
        name: node.name,
        fullName: node.fullName,
        isGroup: isGroup,
        exclude: false,
      };
      this.nodes.push(objectNode);
    }
    return objectNode;
  };

  findNode = (nodeId, objectPath) => {
    return this.nodes.find(function (item) {
      return item.nodeId === nodeId && item.objectPath === objectPath;
    });
  };

  nodesExcludedForObject = (objectPath) => {
    if (!this._objectNodeExcludeLookup) this._buildObjectNodeLookup();

    return this._objectNodeExcludeLookup[objectPath] || { nodes: [], idLookup: {} };
  };

  loadNodesForObject = (contentObject) => {
    let lookupSync = {};
    let lookup = this.nodes.filter(function (item) {
      return item.objectPath === contentObject.objectPath;
    });
    let _this = this;

    const setupJson = JSON.parse(this.setup);
    if (setupJson.sliceGroup) {
      let groupNodes = contentObject.nodesFor(parseInt(setupJson.sliceGroup));
      groupNodes.forEach(function (groupNode) {
        _this._addUpdateNode(contentObject, groupNode, true, lookup);
        lookupSync[groupNode.id] = true;
      });
    } else {
      let objNodes = contentObject.nodes.filter(function (item) {
        return !item.isDescendent && !item.exclude;
      });
      objNodes.forEach(function (node) {
        _this._addUpdateNode(contentObject, node, false, lookup);
        lookupSync[node.id] = true;
      });
    }

    for (let i = 0; i < lookup.length; i++) {
      let ln = lookup[i];
      if (!lookupSync[ln.nodeId]) this.nodes.splice(this.nodes.indexOf(ln), 1);
    }
  };

  _addUpdateNode = (contentObject, node, isGroup, lookup) => {
    let objectNode = lookup.find(function (item) {
      return item.nodeId === node.id;
    });
    if (!objectNode) {
      objectNode = {
        objectPath: contentObject.objectPath,
        nodeId: node.id,
        name: node.name,
        fullName: node.fullName,
        isGroup: isGroup,
        exclude: false,
      };
      this.nodes.push(objectNode);
      lookup.push(objectNode);
    } else {
      objectNode.name = node.name;
      objectNode.fullName = node.fullName;
    }
    return objectNode;
  };

  _buildObjectNodeLookup = () => {
    this._objectNodeLookup = {};
    this._objectNodeExcludeLookup = {};
    for (let i = 0; i < this.nodes.length; i++) {
      let node = this.nodes[i];
      let objectNodes = this._objectNodeLookup[node.objectPath];
      if (!objectNodes) {
        this._objectNodeLookup[node.objectPath] = [node];

        let lookup = { nodes: [], idLookup: {} };
        if (node.exclude) {
          lookup.nodes.push(node);
          lookup.idLookup[node.nodeId] = true;
        }
        this._objectNodeExcludeLookup[node.objectPath] = lookup;
      } else {
        objectNodes.push(node);
        if (node.exclude) {
          let exlookup = this._objectNodeExcludeLookup[node.objectPath];
          exlookup.nodes.push(node);
          exlookup.idLookup[node.nodeId] = true;
        }
      }
    }
  };

  fromTemplate = (templateWidget) => {
    this.templateWidgetId = templateWidget.id;
    this.name = templateWidget.name;
    this.type = templateWidget.type;
    this.rowSpan = templateWidget.rowSpan;
    this.columnSpan = templateWidget.columnSpan;
    this.setup = templateWidget.setup;
    return this;
  };
}
